export const globalState = {
  mode: null,
  totalCart: 0,
  alamatPengiriman: null,
  loadingGeneral: false,
  dataProfile: null,
  dataNotification: null,
  dataCategory: null,
  brand: null,
  qbSession: null,
  qbUnread: 0,
  qbNewMessage: null,
};
